import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import { CategoryContext } from "../CategoryContext";
import { AppContext } from "../../../../Context/AppContext";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import SmallOutlinedButton from "../../../Common/components/SmallOutlinedButton";
import SmallFillButton from "../../../Common/components/SmallFillButton";
import { toast } from "react-toastify";
import _ from "lodash";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "./Attribute.css";
import ViewMoreButton from "../../../Common/components/ViewMoreButton";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

// number of attributes to show at a time
const _max_items_show = 10

const AssociatedAttributes = () => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appContext = useContext(AppContext);
  let industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;
  const { editingItem, setReloadComp } = useContext(CategoryContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });

  const [collapse, setCollapse] = useState(false);
  const [EditPage, setEditPage] = useState(false);
  let [associatedAttributes, setAssociatedAttributes] = useState(null);
  const [attributeList, setAttributeList] = useState(null);
  const [sortedAttributeList, setSortedAttributeList] = useState([]);
  const [checkedAttributes, setCheckedAttributes] = useState([]);
  let [filteredAttList, setFilteredAttList] = useState(sortedAttributeList);
  let [searchString, setSearchString] = useState("");
  const appData = useContext(AppContext);  
  const [showClearAllFlag,setshowClearAllFlag] = useState(true)
  const [viewMoreAttributes, setViewMoreAttributes] = useState(false)
  const [viewMoreAssoAttributes, setViewMoreAssoAttributes] = useState(false)

  useEffect(() => {
    setCheckedAttributes(associatedAttributes);
    const sharedFlag = checkSharedCategories(associatedAttributes || []);
    setshowClearAllFlag(sharedFlag);
  }, [associatedAttributes]);

  useEffect(() => {
    setAssociatedAttributes(null);
    setAttributeList(null);
    setLoading({
      status: "",
      message: "",
    });
  }, [editingItem.id]);

  useEffect(() => {
    if (associatedAttributes === null && collapse) {
      load_associated_attributes();
    }
  }, [collapse]);

  useEffect(() => {
    if (EditPage) {
      load_associated_attributes();
      load_Attributes();
    }
  }, [EditPage]);

  useEffect(() => {
    let arr = [];
    if (
      associatedAttributes &&
      associatedAttributes.length > 0 &&
      attributeList
    ) {
      attributeList.map((i) => {
        let obj = associatedAttributes.find((att) => att.id === i.id);
        if (obj !== undefined) {
          arr.unshift(i);
        } else {
          arr.push(i);
        }
      });
    } else if (attributeList) {
      arr = [...attributeList];
    }

    if (checkedAttributes?.length === 0) {
      arr = updateCategories(arr, associatedAttributes || []);
    } else {
      arr = updateCategories(arr, checkedAttributes || []);
    }

    setSortedAttributeList(arr);
    if (!EditPage) {
      setSortedAttributeList([]);
    }
  }, [attributeList, EditPage]);

  async function load_associated_attributes() {
    setLoading({ status: "Loading", message: "Loading Associated attributes" });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/${editingItem.id}/associatedattributes/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "Success", message: undefined });
      const mappedExistingAttribute = mapExistingAttributes(res.data.data);
      setAssociatedAttributes(mappedExistingAttribute);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
    // setEditPage(false)
  }

  async function handle_save() {
    setLoading({
      status: "Loading",
      message: "updating associated attributes",
    });
    let newlyAdded = [...checkedAttributes];
    let newlyDeleted = [];
    associatedAttributes.map((item) => {
      let index = newlyAdded.findIndex((att) => att.id === item.id);
      if (index === -1) {
        let { id } = item;
        newlyDeleted.push({ id });
      } else {
        newlyAdded.splice(index, 1);
      }
    });

    let res = await ServiceWrapper.doPost(
      `${api_base_url}category/${editingItem.id}/associatedattributes/edit`,
      {
        add_attributes: newlyAdded,
        delete_attributes: newlyDeleted,
        industry_id: industryId,
      },
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({
          status: "Success",
          message: res.data.message,
        });
        setEditPage(false);
        load_associated_attributes();
        setReloadComp((n) => n + 1);
      } else {
        setEditPage(false);
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setEditPage(false);
      setLoading({
        status: "Error",
        message: "Error while saving, Please try after some time.",
      });
    }
    setTimeout(() => {
      setLoading({ status: "Success", message: undefined });
      setEditPage(false);
    }, 2000);
    // Clear Search item
    setSearchString("");
  }

  async function load_Attributes(showStatus = true) {
    if (showStatus) {
      setLoading({
        status: "Loading",
        message: "Loading Attributes",
      });
    }
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/attribute/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      await setAttributeList(ret.data.data);

      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while Loading Attributes",
      });
    }
  }

  function getChecked(id) {
    let obj = checkedAttributes.find((att) => att.id === id);
    return obj !== undefined;
  }

  useEffect(() => {
    if (EditPage && searchString === "") {
      if (checkedAttributes && checkedAttributes.length > -1) {
        let updatedAtt = updateCategories(
          sortedAttributeList,
          checkedAttributes
        );
        updatedAtt = mapFilteredData(updatedAtt, associatedAttributes);
        updatedAtt = sortCatArray(updatedAtt);
        setFilteredAttList(updatedAtt);
      }
    }
  }, [searchString, sortedAttributeList]);

  async function handleSearchAttribute(value) {
    setSearchString(value);
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = sortedAttributeList.filter((item) => {
        return (
          (item.name != null && item.name.toLowerCase().includes(searchval)) ||
          (item.description != null &&
            item.description.toLowerCase().includes(searchval))
        );
      });
      filteredData = updateCategories(filteredData, checkedAttributes);
      filteredData = mapFilteredData(filteredData, associatedAttributes);
      // setFilteredAttList(updatedAtt);
      filteredData = sortCatArray(filteredData);
      setFilteredAttList(filteredData);
    }
  }

  function handle_cancel() {
    setEditPage(false);
    setSearchString("");
    setCheckedAttributes([]);
    setSortedAttributeList([]);
  }

  const fromSelectedToAllAttribute = (categoryItem) => {
    const filteredCheckedItems = checkedAttributes?.filter((item) => {
      return item.id !== categoryItem.id;
    });
    setCheckedAttributes(filteredCheckedItems);
    const catArrData = sortCatArray([...filteredAttList, categoryItem]);
    setFilteredAttList(catArrData);
    if (searchString !== "") {
      setSearchString("");
    }
    const sharedFlag = checkSharedCategories(filteredCheckedItems);
    setshowClearAllFlag(sharedFlag);
  };

  const clearAllCheckedItems = () => {
    const sharedCheckedAttribute = checkedAttributes.filter(
      (item) => item.shared
    );
    const uncheckedCategories = checkedAttributes.filter(
      (item) => !item.shared
    );
    const catArrData = sortCatArray([
      ...filteredAttList,
      ...uncheckedCategories,
    ]);
    setFilteredAttList(catArrData);
    setCheckedAttributes(sharedCheckedAttribute);
    // setSearchString
    setSearchString("");
    setshowClearAllFlag(false);
  };

  function updateCategories(filteredCatAttList, checkedCatArray) {
    for (const catObject of checkedCatArray) {
      filteredCatAttList = filteredCatAttList.filter((item) => {
        return item.id !== catObject.id;
      });
    }
    return filteredCatAttList;
  }

  function mapExistingAttributes(existingAttributeArray) {
    existingAttributeArray = existingAttributeArray?.map((item) => {
      item.removed_from_selected_items = true;
      return item;
    });
    return existingAttributeArray;
  }

  function mapFilteredData(filteredArrData, checkedArrayData) {
    if (checkedArrayData && checkedArrayData.length > 0) {
      for (const item of checkedArrayData) {
        filteredArrData = filteredArrData?.map((attributeData) => {
          if (item.id === attributeData.id) {
            attributeData.removed_from_selected_items = true;
          }
          return attributeData;
        });
      }
    }
    return filteredArrData;
  }

  function sortCatArray(catArr) {
    catArr = _.orderBy(catArr, ["name"], ["asc"]);
    return catArr;
  }

  function checkSharedCategories(allCategoriesArr) {
    let sharedFlag = false;
    allCategoriesArr.map((item) => {
      if (!item.shared) {
        sharedFlag = true;
      }
    });
    return sharedFlag;
  }

  return (
    <>
      <div className="accordion" id="accordionFlushExample">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed shadow-none"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseOne"
            aria-expanded="false"
            aria-controls="flush-collapseOne"
            // style={Utils.borderStyle()}
            style={{
              height: "2.6875rem",
              border: "1px solid #c9cccf",
            }}
          >
            <div>
              {EditPage ? <Label message="Edit " /> : ""}{" "}
              <Label message="Associated Attributes" />
            </div>
          </div>

          {collapse && (
            <>
              {loading.status === "Success" && (
                <>
                  {!EditPage ? (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      {/* <button
                        type="button"
                        className="btn btn-light btn-sm"
                        style={{ color: "#00A2E5" }}
                        onClick={() => {
                          load_associated_attributes();
                        }}
                      >
                        <i className="fa fa-sync-alt" />
                      </button> */}
                      &nbsp;&nbsp;
                      {/* <button
                        className="float-end btn btn-sm btn-outline-primary mb-2"
                        onClick={() => {
                          setEditPage(true);
                        }}
                      >
                        Edit
                      </button> */}
                      <GMSBorderlessButton
                        name="Edit"
                        onClick={() => {
                          if (
                            appData.pm.checkPermission("gmscategory_update")
                          ) {
                            setEditPage(true);
                          } else {
                            toast.info(
                              "You don't have permission to edit associated attribute"
                            );
                          }
                        }}
                      />
                      {/* <a
                        className="link-primary"
                        onClick={() => {
                          setEditPage(true);
                        }}
                        style={{
                          color: "#091caa",
                          textDecoration: "none",
                          fontFamily: "Noto Sans",
                          fontSize: "12px",
                          fontWeight: "500",
                          cursor: "pointer",
                        }}
                      >
                        Edit
                      </a> */}
                    </div>
                  ) : (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      <GMSBorderlessButton
                        name="Reset"
                        onClick={() => {
                          const actualAttributeData = updateCategories(
                            sortedAttributeList,
                            associatedAttributes
                          );
                          setFilteredAttList(actualAttributeData);
                          setCheckedAttributes(associatedAttributes);
                          setSearchString("");
                          const sharedFlag =
                            checkSharedCategories(associatedAttributes);
                          setshowClearAllFlag(sharedFlag);
                        }}
                        disabled={
                          JSON.stringify(associatedAttributes) ===
                          JSON.stringify(checkedAttributes)
                        }
                      />
                      {/* <a
                        className="link-primary"
                        onClick={() =>
                          setCheckedAttributes(associatedAttributes)
                        }
                        disabled={
                          JSON.stringify(associatedAttributes) ===
                          JSON.stringify(checkedAttributes)
                        }
                        style={{
                          color: "#091caa",
                          textDecoration: "none",
                          fontFamily: "Noto Sans",
                          fontSize: "12px",
                          fontWeight: "500",
                          cursor: "pointer",
                          marginRight: "6px",
                        }}
                      >
                        Reset
                      </a> */}
                      &nbsp;
                      <SmallOutlinedButton
                        name="Cancel"
                        onClick={handle_cancel}
                      />
                      {/* <button
                        type="button"
                        className=""
                        onClick={handle_cancel}
                        style={{
                          fontFamily: "Noto Sans",
                          fontSize: "11px",
                          fontWeight: 500,
                          background: "#ffffff",
                          border: "1px solid #091caa",
                          borderRadius: "4px",
                          cursor: "pointer",
                          color: "#091caa",
                          width: "62px",
                          height: "24px",
                          marginRight: "6px",
                        }}
                      >
                        
                        Cancel
                      </button> */}
                      &nbsp;
                      <SmallFillButton
                        name="Save"
                        disabled={
                          JSON.stringify(associatedAttributes) ===
                          JSON.stringify(checkedAttributes)
                        }
                        onClick={() => handle_save()}
                      />
                      {/* <button
                        type="button"
                        className=""
                        disabled={
                          JSON.stringify(associatedAttributes) ===
                          JSON.stringify(checkedAttributes)
                        }
                        onClick={() => handle_save()}
                        style={{
                          fontFamily: "Noto Sans",
                          fontSize: "11px",
                          fontWeight: 500,
                          background: "#091caa",
                          border: "1px solid #091caa",
                          borderRadius: "4px",
                          cursor: "pointer",
                          color: "#ffffff",
                          width: "62px",
                          height: "24px",
                        }}
                      >
                        
                        Save
                      </button> */}
                    </div>
                  )}
                </>
              )}
            </>
          )}

          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
            style={{ border: "none" }}
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              <LoadingSuccessErrorAlert loading={loading} />
              {EditPage ? (
                <div className="selected-category">
                  <div className="selected-category-heading">
                    Selected Attributes
                    <span className="badge badge-light">
                      {checkedAttributes?.length}
                    </span>
                  </div>
                  <div className="selected-category-items">
                    <div className="d-flex flex-wrap">
                      {checkedAttributes && checkedAttributes.length > 0 ? (
                        <>
                          {
                                checkedAttributes.slice(0, 
                                  (viewMoreAssoAttributes) 
                                  ? checkedAttributes.length : Math.min(_max_items_show, checkedAttributes.length)
                                  ).map((item, index) => (
                            <div className="selected-1" key={index}>
                              <input
                                type="checkbox"
                                className="btn-check text-white"
                                name="options-outlined"
                                id={`success-outlined${item.id}`}
                                autoComplete="off"
                                checked={getChecked(item.id)}
                              />
                              {!item.shared ? (
                                <label
                                  className="btn btn-outline-primary btn-sm"
                                  htmlFor={`success-outlined${item.id}`}
                                >
                                  {item.name}
                                  &nbsp;&nbsp;
                                  <span
                                    className="new-close-icon"
                                    onClick={() => {
                                      fromSelectedToAllAttribute(item);
                                    }}
                                  >
                                    <svg
                                      width="19"
                                      height="19"
                                      viewBox="0 0 19 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M14 5L5 14"
                                        stroke="#091CAA"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M5 5L14 14"
                                        stroke="#091CAA"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                </label>
                              ) : (
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Popover id="popover-basic">
                                      <Popover.Body>
                                        Attribute associated with categories,
                                        products, rules or builder cannot be
                                        removed.
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <label
                                    className="unselected-category"
                                    htmlFor={`success-outlined${item.id}`}
                                  >
                                    {item.name}
                                    &nbsp;&nbsp;
                                  </label>
                                </OverlayTrigger>
                              )}
                            </div>
                          ))}
                        </>
                      ) : (
                        <>
                          <div className="no-cat-found">
                            No Attributes found
                          </div>
                        </>
                      )}
                      <ViewMoreButton
                          state = {viewMoreAssoAttributes}
                          handleClick= {() => setViewMoreAssoAttributes(!viewMoreAssoAttributes)}
                          condition = {checkedAttributes?.length > _max_items_show}
                        />
                      
                    </div>
                    {checkedAttributes?.length > 0 && showClearAllFlag ? (
                      <div
                        className="selected-category-clear"
                        onClick={clearAllCheckedItems}
                      >
                        Clear All
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}

              {loading.status === "Success" && (
                <>
                  {EditPage ? (
                    <>
                      {loading.status !== "Loading" && (
                        <div className="card shadow p-0 mb-0 bg-body rounded ">
                          <div
                            style={{ background: "#f2f2f3" }}
                            className="pb-2 d-flex justify-content-between align-items-center"
                          >
                            <div className="ps-4">
                              &nbsp;&nbsp;
                              <Label
                                message="Attributes"
                                fontWeight="600"
                                fontSize={0.875}
                              />
                            </div>
                            <div className="pe-4 pt-4">
                              <input
                                type="search"
                                style={{
                                  width: 264,
                                  paddingTop: 2,
                                  paddingBottom: 2,
                                  placeholderTextColor: "#D8D8DC",
                                  fontSize: 12,
                                  fontFamily: "Noto Sans",
                                }}
                                className="form-control form-control-sm border float-end mb-3 shadow-none"
                                placeholder="Search Attribute"
                                onChange={(e) =>
                                  handleSearchAttribute(e.target.value)
                                }
                                value={searchString}
                              />
                            </div>
                          </div>
                          <div className="d-flex justify-content-end"></div>

                          <div className="d-flex flex-wrap items-center p-3 m-3">
                            {filteredAttList && filteredAttList.length > 0 ? (
                              <>
                                {
                                filteredAttList.slice(0, 
                                  (viewMoreAttributes || searchString!=="") 
                                  ? filteredAttList.length : Math.min(_max_items_show, filteredAttList.length)
                                  ).map((item, index) => (
                                  <div
                                    className=" mb-2"
                                    key={index}
                                    style={{ marginRight: "5px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="btn-check text-white"
                                      name="options-outlined"
                                      id={`success-outlined${item.id}`}
                                      autoComplete="off"
                                      checked={
                                        checkedAttributes &&
                                        checkedAttributes.length > 0 &&
                                        getChecked(item.id)
                                      }
                                      onClick={(e) => {
                                        setshowClearAllFlag(true);
                                        const filteredAttListArr =
                                          filteredAttList?.filter((att) => {
                                            return att.id !== item.id;
                                          });
                                        let checkedArr = [
                                          ...checkedAttributes,
                                          item,
                                        ];

                                        setCheckedAttributes(checkedArr);
                                        setFilteredAttList(filteredAttListArr);
                                        // }
                                      }}
                                    />
                                    <label
                                      // className= {"btn btn-outline-"+`${item.removedFromSelectedItems}?"danger":"primary"} btn-sm`}
                                      className={`btn btn-outline-${
                                        item?.removed_from_selected_items
                                          ? "danger"
                                          : "primary"
                                      } btn-sm`}
                                      htmlFor={`success-outlined${item.id}`}
                                    >
                                      {item.name}
                                    </label>
                                  </div>
                                ))}
                                <ViewMoreButton
                                  state = {viewMoreAttributes}
                                  handleClick= {() => setViewMoreAttributes(!viewMoreAttributes)}
                                  condition = {(searchString==="" && filteredAttList?.length > _max_items_show)}
                                />
                              </>
                            ) : (
                              <>
                                {searchString !== "" ? (
                                  <div
                                    className="alert alert-danger w-100 small p-2"
                                    role="alert"
                                  >
                                    <strong>Sorry!</strong> No Attribute found
                                    matching your search query
                                  </div>
                                ) : (
                                  <>
                                    <div className="no-cat-found">
                                      No Attributes found
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="p-3"
                      style={{
                        borderBottom: "1px solid #c9cccf",
                        borderLeft: "1px solid #c9cccf",
                        borderRight: "1px solid #c9cccf",
                      }}
                    >
                      {associatedAttributes &&
                      associatedAttributes.length > 0 ? (
                        <div>
                          {associatedAttributes.map((item, index) => {
                            return (
                              <div className="d-inline" key={index}>
                                <span
                                  className="badge"
                                  style={{
                                    fontSize: "0.75rem",
                                    backgroundColor: "#F2F2F2",
                                    marginBottom: "10px",
                                    color: "#5c5f62",
                                    fontFamily: "Noto Sans",
                                    fontWeight: "401",
                                    padding: "6px",
                                  }}
                                >
                                  {item.name}
                                </span>
                                &nbsp;&nbsp;
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div
                          className="alert alert-dark small p-2"
                          role="alert"
                        >
                          <strong>Associate Attributes Not Found</strong>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AssociatedAttributes;
